import { useState } from 'react';

const stats = [
  { num: '+5000', label: 'عميل راضٍ', icon: 'ri-user-smile-line' },
  { num: '+200', label: 'علامة تجارية', icon: 'ri-award-line' },
  { num: '+12', label: 'سنة خبرة', icon: 'ri-calendar-check-line' },
  { num: '97%', label: 'نسبة رضا العملاء', icon: 'ri-thumb-up-line' },
];

const stories = [
  {
    id: 1,
    name: 'دار نور العطور',
    owner: 'فاطمة الزهراني',
    role: 'مؤسسة الدار',
    city: 'الرياض، المملكة العربية السعودية',
    avatar: 'https://public.readdy.ai/ai/img_res/06233eaf3c10f6e99e9dae16b0cc202e.jpg',
    story: 'بدأتُ تجارتي من المنزل برأس مال محدود. بعد شراكتي مع العالمية للعطور وصل مبيعاتي إلى أكثر من 80,000 درهم شهرياً خلال عام ونصف فقط. المنتجات الأصلية والدعم المستمر غيّرا مساري التجاري بالكامل.',
    before: '5,000 درهم / شهر',
    after: '80,000 درهم / شهر',
    growth: '+1,500%',
    product: 'عطور فاخرة + كريمات',
    image: 'https://readdy.ai/api/search-image?query=luxurious%20Arabian%20perfume%20boutique%20interior%2C%20golden%20shelves%20with%20premium%20fragrance%20bottles%2C%20elegant%20modern%20retail%20store%2C%20warm%20amber%20lighting%2C%20high-end%20perfumery%20shop%20with%20oud%20and%20rose%20scents%2C%20minimal%20white%20walls%2C%20rich%20wooden%20fixtures&width=600&height=400&seq=store1&orientation=landscape',
    tag: 'قصة نجاح مميزة',
    color: '#C9A961',
  },
  {
    id: 2,
    name: 'بيوتي كيو',
    owner: 'ليلى المنصوري',
    role: 'صاحبة المتجر',
    city: 'دبي، الإمارات العربية المتحدة',
    avatar: 'https://readdy.ai/api/search-image?query=beautiful%20Arab%20woman%20entrepreneur%20professional%20photo%2C%20studio%20lighting%2C%20modern%20makeup%2C%20natural%20confident%20look%2C%20high%20resolution%20portrait&width=200&height=200&seq=owner2&orientation=squarish',
    story: 'أردتُ فتح متجر مستحضرات تجميل احترافي ولم أعرف من أين أبدأ. فريق العالمية ساعدني في اختيار المنتجات الأنسب لسوق دبي وتوفير الكميات بأسعار الجملة. اليوم لدي فرع واحد ومخطط لفتح الثاني.',
    before: '0',
    after: '120,000 درهم / شهر',
    growth: 'بداية من الصفر',
    product: 'مستحضرات تجميل فاخرة',
    image: 'https://readdy.ai/api/search-image?query=modern%20beauty%20cosmetics%20store%20interior%20Dubai%2C%20premium%20makeup%20products%20display%2C%20elegant%20glass%20shelves%20with%20skincare%20creams%20perfumes%2C%20minimalist%20white%20interior%20with%20gold%20accents%2C%20upscale%20beauty%20retail%20environment&width=600&height=400&seq=store2&orientation=landscape',
    tag: 'نجاح سريع',
    color: '#B8860B',
  },
  {
    id: 3,
    name: 'رويال فريجرانس',
    owner: 'خالد البلوشي',
    role: 'مدير التوزيع',
    city: 'مسقط، سلطنة عُمان',
    avatar: 'https://readdy.ai/api/search-image?query=successful%20Arab%20businessman%20professional%20portrait%2C%20mature%20man%20confident%20smile%2C%20traditional%20Gulf%20attire%2C%20studio%20background%2C%20high%20resolution&width=200&height=200&seq=owner3&orientation=squarish',
    story: 'أعمل في توزيع العطور منذ سنوات لكن كنت أعاني من تنوع المنتجات وضمان الجودة. مع العالمية حصلتُ على وكالة حصرية لمنطقتي وتضاعفت أرباحي ثلاث مرات. الشراكة الحقيقية تبدأ من الثقة.',
    before: '40,000 ريال / شهر',
    after: '130,000 ريال / شهر',
    growth: '+225%',
    product: 'عطور خليجية فاخرة',
    image: 'https://readdy.ai/api/search-image?query=traditional%20Arabian%20oud%20and%20musk%20perfumes%20display%2C%20opulent%20Middle%20Eastern%20fragrance%20collection%2C%20premium%20dark%20wood%20shelving%2C%20ornate%20Arabic%20patterns%2C%20exotic%20oriental%20scents%20in%20decorative%20bottles%2C%20rich%20luxury%20atmosphere&width=600&height=400&seq=store3&orientation=landscape',
    tag: 'توزيع إقليمي',
    color: '#8B6914',
  },
];

const achievements = [
  { icon: 'ri-trophy-line', text: 'أفضل موزع للعطور في الخليج 2024' },
  { icon: 'ri-medal-line', text: 'جائزة ريادة الأعمال الرقمية' },
  { icon: 'ri-star-line', text: 'تقييم 4.9/5 من أكثر من 5000 عميل' },
  { icon: 'ri-global-line', text: 'نشط في 7 دول عربية' },
];

export default function SuccessStoriesSection() {
  const [active, setActive] = useState(0);

  return (
    <section className="bg-[#FAFAF7] py-28 px-6 lg:px-12 overflow-hidden" dir="rtl">
      <div className="max-w-7xl mx-auto">

        {/* Header */}
        <div className="text-center mb-20">
          <span className="inline-flex items-center gap-2 bg-[#C9A961]/10 text-[#C9A961] text-xs font-bold tracking-widest uppercase px-4 py-2 rounded-full mb-5">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-trophy-fill text-sm" />
            </div>
            قصص نجاح حقيقية
          </span>
          <h2 className="text-4xl lg:text-5xl font-black text-gray-900 mb-5 leading-tight">
            نجاحات لتجارة<br />
            <span className="text-[#C9A961]">العطور ومستحضرات التجميل</span>
          </h2>
          <p className="text-gray-500 text-lg max-w-2xl mx-auto leading-relaxed">
            شركاؤنا من رجال وسيدات الأعمال الذين حوّلوا أحلامهم التجارية إلى واقع مربح
            بفضل جودة المنتجات والدعم المتواصل من فريق العالمية
          </p>
        </div>

        {/* Stats Bar */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-20">
          {stats.map((s) => (
            <div key={s.label} className="bg-white rounded-2xl px-6 py-7 text-center border border-gray-100 hover:-translate-y-1 transition-transform duration-300">
              <div className="w-12 h-12 flex items-center justify-center bg-[#C9A961]/10 rounded-xl mx-auto mb-4">
                <i className={`${s.icon} text-2xl text-[#C9A961]`} />
              </div>
              <div className="text-3xl font-black text-gray-900 mb-1">{s.num}</div>
              <div className="text-sm text-gray-500 font-medium">{s.label}</div>
            </div>
          ))}
        </div>

        {/* Story Selector Tabs */}
        <div className="flex flex-wrap items-center justify-center gap-3 mb-10">
          {stories.map((s, i) => (
            <button
              key={s.id}
              onClick={() => setActive(i)}
              className={`flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-bold transition-all duration-300 cursor-pointer whitespace-nowrap border ${
                active === i
                  ? 'bg-[#C9A961] text-white border-[#C9A961]'
                  : 'bg-white text-gray-600 border-gray-200 hover:border-[#C9A961] hover:text-[#C9A961]'
              }`}
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className={`ri-store-2-line text-sm ${active === i ? 'text-white' : 'text-[#C9A961]'}`} />
              </div>
              {s.name}
            </button>
          ))}
        </div>

        {/* Featured Story Card */}
        <div className="bg-white rounded-3xl overflow-hidden border border-gray-100">
          <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[460px]">

            {/* Image Side */}
            <div className="relative overflow-hidden order-2 lg:order-1">
              <img
                src={stories[active].image}
                alt={stories[active].name}
                className="w-full h-full object-cover object-top min-h-[280px] lg:min-h-full"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
              {/* Tag */}
              <div className="absolute top-5 right-5">
                <span className="bg-[#C9A961] text-white text-xs font-bold px-4 py-1.5 rounded-full">
                  {stories[active].tag}
                </span>
              </div>
              {/* Growth Badge */}
              <div className="absolute bottom-5 left-5 bg-white/95 rounded-xl px-4 py-3 text-left">
                <div className="text-xs text-gray-500 mb-1">نمو المبيعات</div>
                <div className="text-2xl font-black text-[#C9A961]">{stories[active].growth}</div>
              </div>
            </div>

            {/* Content Side */}
            <div className="p-8 lg:p-12 flex flex-col justify-between order-1 lg:order-2">

              {/* Owner */}
              <div>
                <div className="flex items-center gap-4 mb-7">
                  <div className="w-16 h-16 rounded-2xl overflow-hidden flex-shrink-0 border-2 border-[#C9A961]/30">
                    <img src={stories[active].avatar} alt={stories[active].owner} className="w-full h-full object-cover object-top" />
                  </div>
                  <div>
                    <div className="font-black text-gray-900 text-lg">{stories[active].owner}</div>
                    <div className="text-[#C9A961] text-sm font-semibold">{stories[active].role}</div>
                    <div className="text-gray-400 text-xs mt-0.5 flex items-center gap-1">
                      <div className="w-3 h-3 flex items-center justify-center">
                        <i className="ri-map-pin-line text-xs" />
                      </div>
                      {stories[active].city}
                    </div>
                  </div>
                </div>

                {/* Quote */}
                <div className="relative mb-8">
                  <div className="absolute -top-3 -right-2 text-5xl text-[#C9A961]/20 font-black leading-none select-none">&ldquo;</div>
                  <p className="text-gray-600 text-base leading-relaxed pr-4 italic">
                    {stories[active].story}
                  </p>
                </div>

                {/* Product type */}
                <div className="flex items-center gap-2 mb-7">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-leaf-line text-[#C9A961] text-sm" />
                  </div>
                  <span className="text-sm text-gray-500">التخصص: </span>
                  <span className="text-sm font-bold text-gray-800">{stories[active].product}</span>
                </div>
              </div>

              {/* Before / After */}
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-red-50 rounded-2xl p-4 text-center">
                  <div className="text-xs text-red-400 font-bold mb-1">قبل الشراكة</div>
                  <div className="text-lg font-black text-red-500">{stories[active].before}</div>
                </div>
                <div className="bg-green-50 rounded-2xl p-4 text-center">
                  <div className="text-xs text-green-500 font-bold mb-1">بعد الشراكة</div>
                  <div className="text-lg font-black text-green-600">{stories[active].after}</div>
                </div>
              </div>

              {/* Store name */}
              <div className="mt-5 pt-5 border-t border-gray-100 flex items-center justify-between">
                <span className="text-sm text-gray-400">اسم المتجر</span>
                <span className="text-sm font-black text-gray-800">{stories[active].name}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Small story cards row */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-6">
          {stories.map((s, i) => (
            <button
              key={s.id}
              onClick={() => setActive(i)}
              className={`text-right rounded-2xl p-5 border transition-all duration-300 cursor-pointer ${
                active === i
                  ? 'bg-[#C9A961] border-[#C9A961] text-white'
                  : 'bg-white border-gray-100 hover:border-[#C9A961]/40 text-gray-800'
              }`}
            >
              <div className={`text-xs font-bold mb-2 ${active === i ? 'text-white/70' : 'text-[#C9A961]'}`}>
                {s.tag}
              </div>
              <div className={`font-black text-base mb-1 ${active === i ? 'text-white' : 'text-gray-900'}`}>
                {s.name}
              </div>
              <div className={`text-sm ${active === i ? 'text-white/80' : 'text-gray-500'}`}>
                {s.owner} · {s.city.split('،')[0]}
              </div>
              <div className={`text-2xl font-black mt-3 ${active === i ? 'text-white' : 'text-[#C9A961]'}`}>
                {s.growth}
              </div>
            </button>
          ))}
        </div>

        {/* Achievements Band */}
        <div className="mt-16 bg-gray-900 rounded-3xl px-8 py-10">
          <div className="text-center mb-8">
            <h3 className="text-white text-2xl font-black">إنجازاتنا وجوائزنا</h3>
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
            {achievements.map((a) => (
              <div key={a.text} className="flex flex-col items-center text-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-[#C9A961]/15 rounded-xl">
                  <i className={`${a.icon} text-2xl text-[#C9A961]`} />
                </div>
                <span className="text-white/80 text-sm font-medium leading-snug">{a.text}</span>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="mt-12 text-center">
          <p className="text-gray-500 text-base mb-6">هل تريد أن تكون قصة نجاحك التالية؟</p>
          <a
            href="https://wa.me/971547172715"
            target="_blank"
            rel="nofollow noreferrer"
            className="inline-flex items-center gap-3 bg-[#C9A961] text-white px-10 py-4 rounded-full text-base font-bold hover:bg-[#b8941f] transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-whatsapp-line text-xl" />
            </div>
            ابدأ شراكتك معنا اليوم
          </a>
        </div>

      </div>
    </section>
  );
}
